module.exports = __webpack_public_path__ + "static/media/55_000074.162d53b5.jpg";